import { createApiInstance } from "./apiClient";

const orderUrl = process.env.REACT_APP_ORDER_API_URL;

// eventName is a substring match (see sp_Event_Find), so a generic name like "Trade Show" can match more
// than one year's event — limit defaults higher than 1 so the caller can pick the right one by date rather
// than relying on DB insert order.
export const getEventData = async (eventName, limit = 10) => {
	try {
		const instance = createApiInstance({ baseURL: `${orderUrl}/api/event`, retry: true });

		const queryParameters = new URLSearchParams();

		queryParameters.append("eventName", eventName);
		queryParameters.append("skip", 0);
		queryParameters.append("limit", limit);

		const requestUrl = `?${queryParameters.toString()}`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else if (response.status === 204)
					return {
						error: false,
						success: true,
						message: "no event found"
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
